import React, { Suspense } from 'react';
import { FullscreenView } from '@cp/ds/src/components/modalView/view.fullscreen';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Button } from '@cp/ds/src/components/button';
import { IModalWrapperProps } from './modal.interface';
import { ModalErrorBoundary } from './errorBoundary';

export const FullscreenModal: React.FC<IModalWrapperProps> = ({ open, contentProps, ContentComponent, onClose, onClosed }) => (
  <FullscreenView isOpen={open} onClose={onClose} onClosed={onClosed}>
    <ModalErrorBoundary
      fallbackAction={
        <Button onClick={onClose} size="small" sx={{ marginBlockStart: 2 }}>
          Вернуться
        </Button>
      }
    >
      <Suspense
        fallback={
          <ModalLayout>
            <ModalContainer>
              <ContentSkeleton blocks={4} />
            </ModalContainer>
          </ModalLayout>
        }
      >
        <ContentComponent {...contentProps} />
      </Suspense>
    </ModalErrorBoundary>
  </FullscreenView>
);
